import React from "react";
import { useParams } from "react-router-dom";
import SectionArticlesUI from "./SectionArticlesUI";
import useFetch from "../../hooks/useFetch";

export const SectionArticles = () => {
  const { section } = useParams();

  // Use our local API instead of NYTimes
  let {
    data: articles,
    loading,
    error,
  } = useFetch(`${process.env.REACT_APP_API_URL}/news/${section}`);

  articles = articles.results;

  return (
    <SectionArticlesUI
      section={section}
      articles={articles}
      error={error}
      loading={loading}
    />
  );
};
